export const domainRegEx = /^(?!:\/\/)[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
export const urlRegEx = /^(https?):\/\/[^\s$.?#].[^\s]*$/;
export const urlWithoutProtocolRegEx =
  /^(?:https?:\/\/|s?:\/\/)?(?!www | www\.)[A-Za-z0-9_-]+\.+[A-Za-z0-9./%&=?_:+;-]+$/;
export const linkedinProfileRegex = /^(?:(?:https?:)?\/\/)?(?:www\.)?linkedin\.com\/in\/[^/]+\/?$/i;
/** Matches LinkedIn profile URLs with a required slug after the segment (e.g. linkedin.com/in/username). Allows optional path, query (?...), or hash (#...). */
export const linkedinProfileUrlRegEx =
  /^(https?:\/\/)?([\w-]+\.)?linkedin\.com\/(?:in|pub|profile)\/[A-Za-z0-9._-]+(?:[/?#].*)?$/i;
export const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const urlWithoutProtocolRegExHash =
  /^(?:https?:\/\/|s?:\/\/)?(?!www | www\.)[A-Za-z0-9_-]+\.+[A-Za-z0-9./%&=?_:+;#-]+$/;
